import { voiceTrim, secondsToTime } from "../../Utils/soundTrim";
import { thumbnailPathFrom } from "../../Utils/thumbnailPath";
import React, { useContext, useState, useEffect, useRef } from "react";
import LeftMenu from "../leftmenu.component/leftmenu.component";
import MiddlePortion from "../middle.screen.parent.component/middle.screen.component";
import RightSide from "../slides.menu.components/slideHeader";
import Bottom from "../bottom.component/bottom";
import RecordView from "../../TextToSpeech/RecordView";
import DraggedImg from "../dragger.popup.components/imgDragger.component/previewImg.dragger.component";
import MyContext from "../../context/MyContext";
import AssetsPopup from "../leftmenu.component/SUBcomponents/Assets/assetsPopup";
import ProjectContext from "../../context/ProjectContext";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import TickerContext from "../../context/ticker";
import Lottie from "lottie-web";
import SlideSettings from "../SubMenuDropDown/SubMenuDropDown";
import { LoadingContext } from "../../context/LoadingContext";
import { Edit } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

var TimeLimit = 5 * 60 * 1000;
var onePxEquivalent = 5000 / 4 / 29;

export const Body = (props) => {
  const {
    slides,
    setslides,
    Clear,
    setClear,
    setchanges,
    CurrentProject,
    ChangeCount,
    setChangeCount,
    LayersData,
    setLayersData,
    projectEditorZoom,
    setprojectEditorZoom,
    slide_background_image,
    setSlide_background_image,
    setDeafultLoader,
    bgmusicState,
    setbgmusicState,
  } = useContext(ProjectContext);

  window.addEventListener("beforeunload", (ev) => {
    ev.preventDefault();
    return (ev.returnValue = "Are you sure you want to close?");
  });

  //This code will prevent going back without saving.
  const history = useHistory();
  React.useEffect(() => {
    const unblock = history.block((location, action) => {
      if (true) {
        return window.confirm(
          "Please make sure to save your project before going back. Are you sure you want to go back?"
        );
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, []);
  //This code will prevent going back without saving.

  const { authenticationData, Role } = useContext(AuthContext);

  const [ActiveIndex, setActiveIndex] = useState({
    index: null,
    key: null,
    top: null,
  });

  const [VideoData, setVideoData] = useState({
    apiData: [],
    UserData: [],
  });

  const [isTTS, setIsTTS] = useState(false);
  const [popShow, setpopShow] = useState(false);
  const [enableAutoGuides, setenableAutoGuides] = useState(true);
  const [enableRuler, setenableRuler] = useState(false);
  const [enableGrid, setenableGrid] = useState(false);

  const [stage, setStage] = useState();

  const [isTextInputOrAreaFocus, setisTextInputOrAreaFocus] = useState(false);
  const lottieRef = useRef(null);
  const [UndoLayer, setUndoLayer] = useState([]);

  const [objectsClipboard, setobjectsClipboard] = useState({});

  const [AciveShapeColor, setAciveShapeColor] = useState(null);

  const [RedoLayer, setRedoLayer] = useState([]);

  const [EditorZoom, setEditorZoom] = useState(100);

  const [showRecording, setshowRecording] = useState(false);

  const [timelineZoomVal, setTimelineZoomVal] = useState(6);

  const [unitWidth, setUnitWidth] = useState();

  const [perUnitMS, setPerUnitMS] = useState();

  const [editableObject, seteditableObject] = useState({
    showPanel: false,
    editableItem: [],
    openAnimation: false,
    animationPanelType: "",
  });

  const [pauseState, setpauseState] = useState(false);

  const [TickerPosition, setTickerPosition] = useState(0);

  const [TickerState, setTickerState] = useState(0);
  const [PreviousLayerDataLength, setPreviousLayerDataLength] = useState(0);

  const [Click_TickerPosition, setClick_TickerPosition] = useState(0);

  const [TickerStart, setTickerStart] = useState(false);

  const [MultiDrag, setMultiDrag] = useState([]);

  const [Tl_TotalTime, setTl_TotalTime] = useState({
    time: "00:00:10:00",
    width: 0,
  });

  const [Previous_Tl_TotalTime, setPrevious_TlTotalTime] = useState({
    time: "00:00:10:00",
    width: 0,
  });

  const [LeftToggle, setLeftToggle] = useState("block");

  const [CanvasDisplay, setCanvasDisplay] = useState(true);

  const [checkFunction, setcheckFunction] = useState(false);
  const [scaleLength, setscaleLength] = useState();

  const [TimelineWidth, setTimelineWidth] = useState();

  const [chrPop, setchrPop] = useState(false);

  const [ChrPopData, setChrPopData] = useState([]);

  const [Dragging, setDragging] = useState(false);

  const [CharacterData, setCharacterData] = useState();

  const [LeftPanelActive, setLeftPanelActive] = useState("Scene");

  const [BasicShapes, setBasicShapes] = useState([]);

  const [ProjectAspectRatio, setProjectAspectRatio] = useState("");

  const [premiumActionsArray, setPremiumActionsArray] = useState([]);

  const [Backgrounds, setBackgrounds] = useState({
    type: "",
    color: null,
    Path: null,
    gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
  });

  const [SoundsData, setSoundsData] = useState({
    userData: null,
    adminData: null,
  });
  const [Call_CurrentProject, setCall_CurrentProject] = useState(false);

  useEffect(() => {
    setprojectEditorZoom(EditorZoom);

    if (window.localStorage.getItem("EditorZoom")) {
      window.localStorage.removeItem("EditorZoom");
      window.localStorage.getItem("EditorZoom", EditorZoom);
    } else {
      window.localStorage.getItem("EditorZoom", EditorZoom);
    }
  }, [EditorZoom]);

  const [characterId, setCharacterId] = useState(null);

  const [characterEditor, setCharacterEditor] = useState(false);

  const [IsPressedShiftKey, setIsPressedShiftKey] = useState(false);

  const [Call_ScreenShot, setCall_ScreenShot] = useState(false);

  const [isCrop, setIsCrop] = useState(false);

  //const [AIContentPopup,setAIContentPopup] = useState(false);
  // useEffect(() => {
  //   for (let i = 0; i < slides.length; i++) {
  //     if (slides[i].IsActive === true) {
  //       let width = calculateWidthByDuration(slides[i].TotalLength)
  //       let MiniTime = msToTimeMini(width * onePxEquivalent)
  //       slides[i].SmallTime = MiniTime
  //       setTl_TotalTime({
  //         time: slides[i].TotalLength,
  //         width: width
  //       })
  //       setBackgrounds(slides[i].SlideBackground)
  //       if (slides[i].LayerData.length === 0) {
  //         setLayersData([])
  //       } else {
  //         setLayersData(slides[i].LayerData)
  //       }
  //       break
  //     }
  //   }
  // }, [slides])

  // const loadImage = url => {
  //   return new Promise((resolve, reject) => {
  //     var image = new Image();
  //     image.onload = function () {
  //       resolve(image)
  //     }
  //     image.src = url;
  //   });
  // };

  const [ImageData, setImageData] = useState({
    apiData: [],
    UserData: [],
  });

  useEffect(() => {
    changeTimelineZoomVal(6);
  }, []);

  const changeTimelineZoomVal = async (val) => {
    let PUM;
    let W;
    setTimelineZoomVal(val);

    switch (parseInt(val)) {
      case 0:
        setUnitWidth(34 - 1 + "px"); //cursor width is 1px so we minus 1px

        PUM = 25000;
        onePxEquivalent = PUM / 4 / 34;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 34 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 34);

        break;
      case 1:
        setUnitWidth(29 - 1 + "px");
        PUM = 20000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 2:
        setUnitWidth(29 - 1 + "px");
        PUM = 15000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 3:
        setUnitWidth(29 - 1 + "px");
        PUM = 10000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 4:
        setUnitWidth(29 - 1 + "px");
        PUM = 5000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 5:
        setUnitWidth(29 - 1 + "px");
        PUM = 2000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 6:
        setUnitWidth(29 - 1 + "px");
        PUM = 1000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);
    }
    setTickerPosition(TickerPosition);

    let TotalWidth = calculateWidthByDuration(Tl_TotalTime.time);
    let TotalTime = Tl_TotalTime.time;

    // debugger
    // setPrevious_TlTotalTime({
    //   time: Tl_TotalTime.time,
    //   width: Tl_TotalTime.width
    // })

    if (window.localStorage.getItem("onePxEquivalent")) {
      window.localStorage.removeItem("onePxEquivalent");
      window.localStorage.setItem("onePxEquivalent", onePxEquivalent);
    } else {
      window.localStorage.setItem("onePxEquivalent", onePxEquivalent);
    }

    setTl_TotalTime({
      time: TotalTime,
      width: TotalWidth,
    });
    const _slide = Array.from(slides);
    for (let i = 0; i < _slide.length; i++) {
      if (_slide[i].IsActive) {
        if (
          _slide[i].scaleEnd !== calculateWidthByDuration(_slide[i].TotalLength)
        ) {
          _slide[i].scaleEnd = calculateWidthByDuration(_slide[i].TotalLength);
          setslides(_slide);
        }
      }
    }

    if (LayersData.length != 0) {
      ctrlZ();

      const newArray = Array.from(LayersData);

      for (var i = 0; i < newArray.length; i++) {
        let oldWidthOnTimeline = LayersData[i].widthOnTimeline;
        LayersData[i].TimelineZoom = parseInt(val); //now its is directly used from state in  the edtiortracker
        LayersData[i].widthOnTimeline = calculateWidthByDuration(
          LayersData[i].duration
        );

        if (newArray[i].type == "Video") {
          // LayersData[i].VideoActualLength_withTMZoom = calculateWidthByDuration(LayersData[i].VideoActualWidth);
        }
        LayersData[i].startPositionOnTimeline = calculateWidthByDuration(
          LayersData[i].startTime
        );
        LayersData[i].startTransitionWidth =
          (LayersData[i].startTransitionWidth / oldWidthOnTimeline) *
          LayersData[i].widthOnTimeline;
        LayersData[i].endTransitionWidth =
          (LayersData[i].endTransitionWidth / oldWidthOnTimeline) *
          LayersData[i].widthOnTimeline;

        if (LayersData[i].TTSName && LayersData[i].TTSName != "") {
          // A trimmed voice keeps its trimmed length (see VoiceTrimSettings).
          const _voiceLength =
            LayersData[i].TTSTrimStart !== undefined || LayersData[i].TTSTrimEnd !== undefined
              ? secondsToTime(voiceTrim(LayersData[i]).length)
              : LayersData[i].TTSDuration;
          LayersData[i].completeWithOfTTS = calculateWidthByDuration(_voiceLength);
          LayersData[i].midTransitionWidths = calculateWidthByDuration(_voiceLength);
          if (_voiceLength !== LayersData[i].TTSDuration)
            LayersData[i].TTSWidthOnTimeline = LayersData[i].midTransitionWidths;
          LayersData[i].StartAudioTime = calculateWidthByDuration(
            LayersData[i].StartTimeOfTTS
          );
          if (
            LayersData[i].startPositionOnTimeline < LayersData[i].StartAudioTime
          ) {
            LayersData[i].div_TTS_Left =
              LayersData[i].StartAudioTime -
              LayersData[i].startPositionOnTimeline;
          }

          LayersData[i].LastStartPositionOnTimeline = calculateWidthByDuration(
            LayersData[i].StartTimeOfTTS
          );
        }

        LayersData[i].midTransitionWidth =
          (LayersData[i].midTransitionWidth / oldWidthOnTimeline) *
          LayersData[i].widthOnTimeline;
      }

      setLayersData(newArray);
    }
  };

  // Resizes a picture for the slide thumbnail. When the picture is an address on another site that
  // does not allow reading its pixels (the base64 conversion fell back to the plain address), the
  // canvas cannot be read: the picture is then used as it is instead of throwing an uncaught
  // SecurityError ("Tainted canvases may not be exported").
  var resizedataURL = function (base64, wantedWidth, wantedHeight) {
    return new Promise(function (resolve) {
      if (!base64 || typeof base64 !== "string") return resolve(base64);
      var img = document.createElement("img");
      if (/^https?:/i.test(base64)) img.crossOrigin = "anonymous";
      img.onload = function () {
        try {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          canvas.width = wantedWidth;
          canvas.height = wantedHeight;
          ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
          resolve(canvas.toDataURL("image/jpeg", 0.85));
        } catch (e) {
          resolve(base64);
        }
      };
      img.onerror = function () {
        resolve(base64);
      };
      img.src = base64;
    });
  };
  // take screenshot of active slide
  useEffect(() => {
    if (Call_ScreenShot) {
      CaptureSS_Node();
    }
  }, [Call_ScreenShot]);

  const CaptureSS_Node = async () => {
    let canvasHeight, canvasWidth;
    const _slide = Array.from(slides);
    var _currentSlidKey = null;
    for (let i = 0; i < _slide.length; i++) {
      if (_slide[i].IsActive) {
        slides[i].LayerData = LayersData; // as before: the active slide holds the current layers
        slides[i].slideLoader = true; // the slide list shows its loader until the thumbnail is back
        // Work on copies. The steps below turn pictures, shapes and characters into embedded
        // images for the thumbnail only; done on the editor's own layers, they replaced each
        // picture's link with a full copy that was then saved with the project (megabytes).
        _slide[i] = {
          ..._slide[i],
          SlideBackground: { ...(_slide[i].SlideBackground || {}) },
          LayerData: LayersData.map((layer) => ({ ...layer })),
        };
        _slide[i].CurrentProject = CurrentProject;
        _currentSlidKey = _slide[i].key;
        _slide[i].slideLoader = true;

        let _editor = document.getElementsByClassName("Editor")[0];
        _slide[i].clientHeight = _editor.clientHeight;
        _slide[i].clientWidth = _editor.clientWidth;

        if (_slide[i].SlideBackground.type === "image") {
          _slide[i].SlideBackground.convertedImage = await loadImage(
            authenticationData.ApiBaseURL + "/" + _slide[i].SlideBackground.Path
          );
          resizedataURL(
            _slide[i].SlideBackground.convertedImage,
            1920,
            1080
          ).then(async (newurl) => {
            _slide[i].SlideBackground.convertedImage = newurl;
          });
        } else if (_slide[i].SlideBackground.type === "Animated") {
          _slide[i].SlideBackground.convertedAnimated = await loadImage(
            authenticationData.ApiBaseURL + "/" + _slide[i].SlideBackground.Path
          );
          resizedataURL(
            _slide[i].SlideBackground.convertedAnimated,
            1920,
            1080
          ).then(async (newurl) => {
            _slide[i].SlideBackground.convertedAnimated = newurl;
          });
        } else if (_slide[i].SlideBackground.type === "gradient") {
          _slide[i].gradientBackground = _editor.style.background;
        }

        for (let j = 0; j < _slide[i].LayerData.length; j++) {
          if (_slide[i].LayerData[j].type === "image") {
            _slide[i].LayerData[j].ImageSrc = await loadImage(
              _slide[i].LayerData[j].ImageSrc
            );
            // resizedataURL(_slide[i].LayerData[j].ImageSrc, 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].ImageSrc = newurl;
            //   _slide[i].LayerData[j].ConvertedImageSrc = newurl;
            // })
          } else if (_slide[i].LayerData[j].type === "Shape") {
            var path = _slide[i].LayerData[j].ShapePath.replace(
              authenticationData.ApiBaseURL + "/",
              ""
            );
            _slide[i].LayerData[j].convertedShapePath = await loadImage(path);
            resizedataURL(
              _slide[i].LayerData[j].convertedShapePath,
              1920,
              1080
            ).then(async (newurl) => {
              _slide[i].LayerData[j].convertedShapePath = newurl;
            });
          } else if (_slide[i].LayerData[j].type === "Video") {
            _slide[i].LayerData[j].ConvertedImageSrc = await loadImage(
              _slide[i].LayerData[j].ImageSrc
            );
            // resizedataURL(_slide[i].LayerData[j].ConvertedImageSrc , 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].ImageSrc = newurl;
            //   _slide[i].LayerData[j].ConvertedImageSrc = newurl;
            // })
          } else if (_slide[i].LayerData[j].type === "Props") {
            _slide[i].LayerData[j].convertedPropsImage = await loadImage(
              _slide[i].LayerData[j].PropImage
            );

            // resizedataURL(_slide[i].LayerData[j].convertedPropsImage, 1920, 1080).then(async (newurl) => {
            //   _slide[i].LayerData[j].convertedPropsImage = newurl;
            // });
          } else if (_slide[i].LayerData[j].type === "Character") {
            let charDiv = document.getElementById(
              "Outer-" + _slide[i].LayerData[j].AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                _slide[i].LayerData[j].convertedSvg = await loadCharacter(svg);
              }
            }
          } else if (_slide[i].LayerData[j].type === "AnimatedText") {
            let charDiv = document.getElementById(
              "Outer-" + _slide[i].LayerData[j].AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                _slide[i].LayerData[j].convertedSVG = await loadCharacter(svg);
              }
            }
          } else if (_slide[i].LayerData[j].type === "basicShape") {
            let charDiv = document.getElementById(
              "default-shape-" + _slide[i].LayerData[j].key
            );

            _slide[i].LayerData[j].convertedBasicShape = await loadBasicShape(
              charDiv
            );

            resizedataURL(
              _slide[i].SlideBackground.convertedBasicShape,
              1920,
              1080
            ).then(async (newurl) => {
              _slide[i].SlideBackground.convertedBasicShape = newurl;
            });
          }
        }
        _slide[i].CurrentProject = null;
      }
    }

    _slide.forEach((element) => {
      element.LayerData.forEach((element) => {
        element.EditorZoom = projectEditorZoom;
        element.index = element.layerIndex;
        if (element.type === "Character") {
          //element.JSONValue = null;
          //element.OriginalJSONValue= null;
        }
      });
    });
    var activeSlideData = _slide.filter((x) => x.IsActive == true);
    if (CurrentProject.canvasSize == "16:9") {
      canvasWidth = 1920;
      canvasHeight = 1080;
    } else if (CurrentProject.canvasSize == "9:16") {
      canvasWidth = 1080;
      canvasHeight = 1920;
    } else if (CurrentProject.canvasSize == "1:1") {
      canvasWidth = 1080;
      canvasHeight = 1080;
    }

    let exportObj = {
      SlideData: JSON.stringify(activeSlideData),
      Width: canvasWidth,
      Height: canvasHeight,
      bpath: "",
      FileName: CurrentProject.previewImagePath,
      ProjectId: CurrentProject.id,
      ProjectName: CurrentProject.projectName,
      CanvasSize: CurrentProject.canvasSize,
      CurrentSlideKey: _currentSlidKey,
      // projectEditorZoom:projectEditorZoom
    };

    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    var formData = new FormData();
    formData.append("value", JSON.stringify(exportObj));
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Export/CatureSSNode",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        const concat = thumbnailPathFrom(response.data);

        setCall_ScreenShot(false);
        setChangeCount(0);
        setSlide_background_image({
          path: concat,
          slide_key: response.data.key,
        });
        // for (let i = 0; i < slides.length; i++) {
        //   if (slides[i].IsActive && _slide[i].key==_currentSlidKey) {
        //     slides[i].SlideImage = concat;
        //   }
        // }
        //setslides(_slide);
      })
      .catch((error) => {
        // The thumbnail could not be made: keep the old one and stop the slide's loader
        // (before, the loader kept spinning and no later thumbnail was taken).
        console.log("Slide thumbnail could not be created.", error);
        setCall_ScreenShot(false);
        const _active = slides.find((s) => s.key === _currentSlidKey);
        setSlide_background_image({
          path: _active ? _active.SlideImage : null,
          slide_key: _currentSlidKey,
        });
      });
  };

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        resolve(xml);
        //resolve(div);
      } catch (error) { }
    });
  }

  function loadBasicShape(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        resolve(image64);
      } catch (error) { }
    });
  }

  function loadImage(path) {
    return new Promise(async (resolve, reject) => {
      if (!path.includes(".svg")) {
        let imSrc = path;
        if (
          !path.includes("data:image/png;base64") &&
          !path.includes("data:image/jpeg;base64")
        ) {
          imSrc = await getImageSrc(path);
        }
        resolve(imSrc);
        // let img = new Image();
        // img.onload = function () {
        //   resolve(img);
        // };
        // img.src = imSrc;
      } else if (path.includes(".svg")) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL + "/api/Asset/getAsset?path=" + path,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .catch(() => ({ data: path }))
          .then((response) => {
            resolve(response.data);

            // console.log(response.data);
            // let img = new Image();
            // img.onload = function () {
            //   resolve(img);
            // };
            // img.src = response.data;
          });
      }
    });
  }

  function getImageSrc(url) {
    // Falls back to the plain URL if the conversion fails, instead of waiting forever.
    return ImageURLToBase64(url).catch(() => url);
  }

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];

      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
          "/api/Images/ImageURLToBase64?url=" +
          url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() === "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;

            resolve(baseStr);
          } else {
            reject();
          }
        })
        .catch((error) => {
          //console.log(error);
          reject();
        });
    });
  };

  // uncomment this to save project on the backend

  useEffect(() => {
    // if (ChangeCount === 0) {
    //   setchanges(false);
    //   // setReloder(false)
    // } else {
    //   setchanges(false);
    //   // setReloder(true)
    // }

    if (ChangeCount > 0) {
      setchanges(false);
    }
  }, [ChangeCount]);

  const ctrlZ = () => {
    var stack = [...UndoLayer];
    let PrevArray = [...LayersData];

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
  };

  // event.keyCode is deprecated and is 0 for some keyboards, input tools and automation; the key
  // name is used when it is missing. Cmd works like Ctrl, so copy/paste/undo also work on a Mac.
  const KEY_CODES = { Enter: 13, " ": 32, ArrowLeft: 37, ArrowUp: 38, ArrowRight: 39, ArrowDown: 40 };
  const keyCodeOf = (event) => {
    if (event.keyCode) return event.keyCode;
    const k = event.key || "";
    if (KEY_CODES[k]) return KEY_CODES[k];
    return k.length === 1 ? k.toUpperCase().charCodeAt(0) : 0;
  };

  const KeyDownListen = (event) => {
    const keyCode = keyCodeOf(event);
    const ctrl = event.ctrlKey === true || event.metaKey === true;
    if (ctrl && !event.shiftKey && (event.key === "z" || event.key === "Z")) {
      var stack = [...UndoLayer];
      var CurrentArray = clone(LayersData);
      var redoArray = [...RedoLayer];
      if (stack.length != 0) {
        var pop = stack.pop();
        console.log('pop', pop)
        setUndoLayer(stack);
        redoArray.push(CurrentArray);
        setRedoLayer(redoArray);
  
        let poparray;
  
        if (stack.length >= 0) {
          let arr = [];
  
          for (let pl = 0; pl < pop.length; pl++) {
            arr.push(pop[pl]);
          }
  
          arr.map((item) =>{
            item.Editable = false
  
          })
          setLayersData(arr);
          const updatedReverseLayer = ReverseLayer.map((reverseLayerItem) => {
            const correspondingLayerData = arr.find((layerDataItem) =>
             layerDataItem.Name === reverseLayerItem.Name);
            return correspondingLayerData ? { ...correspondingLayerData } : reverseLayerItem;
          });
          setReverseLayer(updatedReverseLayer);
          // setPreviousLayersData(arr)
          poparray = JSON.parse(JSON.stringify(arr));
        }
  
        if (poparray && poparray.length != 0) {
          if (poparray[0].TimelineZoom) {
            TimelineUndo(poparray[0].TimelineZoom);
          } else {
            TimelineUndo(3);
          }
        }
        seteditableObject({ showPanel: false, editableItem: [] });
  
        //setChangeCount(ChangeCount - 1)
      }
    }

    if (event.nativeEvent.shiftKey === true) {
      if (!IsPressedShiftKey) setIsPressedShiftKey(true);
    }

    if (
      event.nativeEvent.shiftKey === true &&
      ctrl &&
      (event.nativeEvent.key === "Z" || event.nativeEvent.key === "z")
    ) {
      var Undostack = [...UndoLayer];
      var CurrentArray = clone(LayersData);
      var redoArray = [...RedoLayer];
  
      if (redoArray.length != 0) {
        var pop = redoArray.pop();
  
        setRedoLayer(redoArray);
        Undostack.push(CurrentArray);
        setUndoLayer(Undostack);
        setLayersData(pop);
  
        let poparray = JSON.parse(JSON.stringify(pop));
        if (poparray.length != 0) {
          if (poparray[0].TimelineZoom) {
            TimelineUndo(poparray[0].TimelineZoom);
          }
        }
        const updatedReverseLayer = ReverseLayer.map((reverseLayerItem) => {
          const correspondingLayerData = pop.find((layerDataItem) => layerDataItem.Name === reverseLayerItem.Name);
          return correspondingLayerData ? { ...correspondingLayerData } : reverseLayerItem;
        });
        setReverseLayer(updatedReverseLayer);
      }
  
      setChangeCount(ChangeCount + 1)
    }

    if (event.key === "Delete") {
      var array = Array.from(LayersData);
      //let changeArray = array.filter(item => item.Editable !== true)
      //var delType;
      let changeArray = array.filter(function (value, index, arr) {
        // if(value.type === "AnimatedText")
        // {
        if (value.toolbar !== true) {
          value.Added = true;
          return value;
        } else {
          Lottie.destroy(value.AnimationId);
        }
        // }
        // else if (value.Editable !== true) {
        //   return value;
        // } else {
        //   //delType = value.type
        //   if (value.type == "Props") {
        //     Lottie.destroy(value.AnimationId);
        //   } else if (value.type == "Character") {
        //     Lottie.destroy(value.AnimationId);
        //   }
        // }
      });

      setLayersData(changeArray);
      //leftPanelHide
      seteditableObject({ showPanel: false, editableItem: [] });
    }

    const calculatePreviousSlidesSeconds = (duration) => {
      var tempArr = duration.split(":");
      var hours = parseInt(tempArr[0]);
      var minutes = parseInt(tempArr[1]);
      var seconds = parseInt(tempArr[2]);
      var milliseconds = parseInt(tempArr[3]);
      var totalMilliseconds =
        (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
      return totalMilliseconds / 1000;
    };
    const playBgMusicWithTicker = () => {
      try {
        var previousSlideTime = 0;
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].IsActive === true) {
            for (let j = 0; j <= i - 1; j++) {
              previousSlideTime =
                previousSlideTime +
                calculatePreviousSlidesSeconds(slides[0].TotalLength);
            }
          }
        }

        var currentSlideTimeSECONDS =
          calculateTimeByWidth(TickerPosition) / 1000;
        var previousSlideTimeSECONDS = previousSlideTime;
        var element = document.getElementById("bgmusicAudioPlayer");
        element.src = authenticationData.ApiBaseURL + "/" + bgmusicState.src;
        element.volume = bgmusicState.volume / 100;
        if (
          bgmusicState.duration >
          previousSlideTimeSECONDS + currentSlideTimeSECONDS
        ) {
          element.currentTime =
            previousSlideTimeSECONDS + currentSlideTimeSECONDS;
          element.play();
        }
      } catch (exp) {
        console.log("Error in playBgMusicWithTicker", exp);
      }
    };
    const stopBgMusicWithTicker = () => {
      try {
        var element = document.getElementById("bgmusicAudioPlayer");
        //element.src = authenticationData.ApiBaseURL + "/" + bgmusicState.src;
        element.pause();
      } catch (exp) {
        console.log("Error in stopBgMusicWithTicker", exp);
      }
    };
    // Crop Image on Enter
    if (keyCode === 13) {
      setIsCrop(!isCrop);
    }
    // move right with right key
    if (keyCode === 39) {
      if (!isTextInputOrAreaFocus) {
        event.preventDefault();
        var array = Array.from(LayersData);
        //did this for multiDrag Moving
        let multiDragArr = [];
        array.map((item, index) => {
          if (item.showDiv === true) {
            item.x = item.x + 1;
            if (event.nativeEvent.shiftKey === true) {
              item.x = item.x + 10;
            }
            item.Editable = false;
          }
          //did this for multiDrag Moving
          else if (item.InMultiDrag === true) {
            item.x = item.x + 1;
            if (event.nativeEvent.shiftKey === true) {
              item.x = item.x + 10;
            }
            item.Editable = false;
            multiDragArr.push(item);
          }
        });
        setLayersData(array);

        //did this for multiDrag Moving
        setMultiDrag(multiDragArr);
      }
    }
    // move left with left key
    if (keyCode === 37) {
      if (!isTextInputOrAreaFocus) {
        event.preventDefault();
        var array = Array.from(LayersData);
        //did this for multiDrag Moving
        let multiDragArr = [];
        array.map((item, index) => {
          if (item.showDiv === true) {
            item.x = item.x - 1;
            if (event.nativeEvent.shiftKey === true) {
              item.x = item.x - 10;
            }
            item.Editable = false;
          }
          //did this for multiDrag Moving
          else if (item.InMultiDrag === true) {
            item.x = item.x - 1;
            if (event.nativeEvent.shiftKey === true) {
              item.x = item.x - 10;
            }
            item.Editable = false;
            multiDragArr.push(item);
          }
        });
        setLayersData(array);
        //did this for multiDrag Moving
        setMultiDrag(multiDragArr);
      }
    }
    // move up with up key
    if (keyCode === 38) {
      if (!isTextInputOrAreaFocus) {
        event.preventDefault();
        var array = Array.from(LayersData);
        //did this for multiDrag Moving
        let multiDragArr = [];
        array.map((item, index) => {
          if (item.showDiv === true) {
            item.y = item.y - 1;
            if (event.nativeEvent.shiftKey === true) {
              item.y = item.y - 10;
            }
            item.Editable = false;
          }
          //did this for multiDrag Moving
          else if (item.InMultiDrag === true) {
            item.y = item.y - 1;
            if (event.nativeEvent.shiftKey === true) {
              item.y = item.y - 10;
            }
            item.Editable = false;
            multiDragArr.push(item);
          }
        });
        setLayersData(array);
        //did this for multiDrag Moving
        setMultiDrag(multiDragArr);
      }
    }
    // move down with down key
    if (keyCode === 40) {
      if (!isTextInputOrAreaFocus) {
        event.preventDefault();
        var array = Array.from(LayersData);
        //did this for multiDrag Moving
        let multiDragArr = [];
        array.map((item, index) => {
          if (item.showDiv === true) {
            item.y = item.y + 1;
            if (event.nativeEvent.shiftKey === true) {
              item.y = item.y + 10;
            }
            item.Editable = false;
          }
          //did this for multiDrag Moving
          else if (item.InMultiDrag === true) {
            item.y = item.y + 1;
            if (event.nativeEvent.shiftKey === true) {
              item.y = item.y + 10;
            }
            item.Editable = false;
            multiDragArr.push(item);
          }
        });
        setLayersData(array);
        //did this for multiDrag Moving
        setMultiDrag(multiDragArr);
      }
    }

    // Play with Space key
    if (keyCode === 32) {
      console.log("space");
      var element = document.activeElement.tagName;
      if (document.activeElement.id === "pauseRef") {
        element = "DIV";
      }
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        console.log("play video");
        if (!pauseState) {
          const data = Lottie.getRegisteredAnimations();
          LayersData.map((value) => {
            value.ComingFromToolbar = true;
            value.player = false;
            data.map((LottieData) => {
              if (LottieData.name == value.AnimationId) {
                Lottie.destroy(value.AnimationId);
              }
            });
          });
          //Doing this to fix jerk on Start from Play
          setcheckFunction(false);
          setIsPlayClicked(true);
          setCanvasDisplay(false);
          setpauseState(true);
          document.getElementById("pauseRef").blur();
          document.getElementsByClassName("body")[0].focus();
          playBgMusicWithTicker();
        } else {
          setcheckFunction(false);
          LayersData.map((value) => {
            value.ComingFromToolbar = true;
          });
          setIsPlayClicked(false);
          setCanvasDisplay(true);
          setpauseState(false);
          document.getElementById("pauseRef").blur();
          document.getElementsByClassName("body")[0].focus();
          stopBgMusicWithTicker();
        }
      }
    }

    // Enable Auto Guides
    if (keyCode === 71 && event.shiftKey === true) {
      if (!enableAutoGuides) {
        setenableAutoGuides(true);
        toast.success("Enabled Auto Guides");
      } else {
        setenableAutoGuides(false);
        toast.warning("Disabled Auto Guides");
      }
    }

    // Enable Ruler
    if (keyCode === 82 && event.shiftKey === true) {
      var element = document.activeElement.tagName;
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        if (!enableRuler) {
          setenableRuler(true);
          toast.success("Enabled Ruler");
        } else {
          setenableRuler(false);
          toast.warning("Disabled Ruler");
        }
      }
    }

    // Enable Grid
    if (keyCode === 69 && event.shiftKey === true) {
      var element = document.activeElement.tagName;
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        if (!enableGrid) {
          setenableGrid(true);
          toast.success("Enabled Grid");
        } else {
          setenableGrid(false);
          toast.warning("Disabled Grid");
        }
      }
    }

    // Copy Element to Clipboard
    if (keyCode === 67 && ctrl) {
      var element = document.activeElement.tagName;
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        event.preventDefault();

        var array = Array.from(LayersData);
        array.map((item, index) => {
          if (item.showDiv === true) {
            setobjectsClipboard(item);
            toast.success("Element Copied");
          }
        });
      }
    }

    // Sound layer Cut (Ctrl + X) Implementation

    if (keyCode === 88 && ctrl) {
      var element = document.activeElement.tagName;
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        event.preventDefault();
        const array = Array.from(LayersData);
        for (var i in array) {
          if (array[i].Editable == true && array[i].type == "audio") {
            array[i].startPositionOnTimeline = 0;
            array[i].LastStartPositionOnTimeline = 0;
            //array[i].startSound=0;
            array[i].startTime = "00:00:00:000";
            setobjectsClipboard(array[i]);
            array.splice(i, 1);
            break;
          }
        }

        setLayersData(array);
      }
    }

    // Past Element from Clipboard
    if (keyCode === 86 && ctrl) {
      var element = document.activeElement.tagName;
      if (element != "SPAN" && element != "TEXTAREA" && element != "INPUT") {
        event.preventDefault();
        var obj = JSON.parse(JSON.stringify(objectsClipboard));
        if (obj.AnimationId != undefined) {
          var topIndex = 0;
          if (LayersData.length > 0) {
            topIndex = LayersData[LayersData.length - 1].layerIndex;
            topIndex = topIndex + 1;
          }
          var checkKey = 0;
          for (var i = 0; i < LayersData.length; i++) {
            if (LayersData[i].key >= checkKey) {
              checkKey = LayersData[i].key;
            }
          }
          obj.key = checkKey + 1;
          obj.Name = obj.Name + "-copy";
          // A new id that no layer on any slide has (the preview and export find layers by id).
          const usedIds = new Set();
          slides.forEach((s) => (s.IsActive ? LayersData : s.LayerData || []).forEach((l) => l && usedIds.add(l.AnimationId)));
          let newId;
          do {
            newId = Math.random().toString(36).slice(2, 10);
          } while (usedIds.has(newId));
          obj.AnimationId = newId;
          obj.layerIndex = topIndex;
          obj.Added = true;
          // Placed a little to the side so the copy is visible, and selected instead of the original.
          if (typeof obj.x === "number" && obj.type !== "audio") obj.x += 20;
          if (typeof obj.y === "number" && obj.type !== "audio") obj.y += 20;
          if (typeof obj.originalX === "number" && obj.type !== "audio") obj.originalX = obj.x;
          if (typeof obj.originalY === "number" && obj.type !== "audio") obj.originalY = obj.y;
          var finalJson = JSON.parse(JSON.stringify(obj));
          ctrlZ(); // the paste can be undone
          const others = LayersData.map((l) => (l.showDiv || l.Editable ? { ...l, showDiv: false, Editable: false, toolbar: false } : l));
          setLayersData(others.concat(finalJson));
          toast.success("Element Pasted");
        } else {
          navigator.clipboard
            .readText()
            .then((text) => {
              const array = Array.from(LayersData);
              for (let i = 0; i < array.length; i++) {
                if (array[i].edit === "true" && array[i].type === "text") {
                  array[i].text = text;
                  setLayersData(array);
                  break;
                }
              }
            })
            .catch((err) => {
              console.error("Failed to read clipboard contents: ", err);
            });
        }
      }
    }
  };

  const KeyUpListen = (event) => {
    if (event.nativeEvent.shiftKey === false) {
      if (IsPressedShiftKey) setIsPressedShiftKey(false);
    }
  };

  const TimelineUndo = async (val) => {
    let PUM;
    let W;
    setTimelineZoomVal(val);

    switch (parseInt(val)) {
      case 0:
        setUnitWidth(34 - 1 + "px"); //cursor width is 1px so we minus 1px

        PUM = 25000;
        onePxEquivalent = PUM / 4 / 34;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 34 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 34);

        break;
      case 1:
        setUnitWidth(29 - 1 + "px");
        PUM = 20000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 2:
        setUnitWidth(29 - 1 + "px");
        PUM = 15000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 3:
        setUnitWidth(29 - 1 + "px");
        PUM = 10000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 4:
        setUnitWidth(29 - 1 + "px");
        PUM = 5000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 5:
        setUnitWidth(29 - 1 + "px");
        PUM = 2000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);

        break;
      case 6:
        setUnitWidth(29 - 1 + "px");
        PUM = 1000;
        onePxEquivalent = PUM / 4 / 29;
        setPerUnitMS(PUM);
        setscaleLength(TimeLimit / PUM);
        W = 29 * 4 * (TimeLimit / PUM);
        setTimelineWidth(W + 29);
    }
  };

  const clone = (obj) => {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null === obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  };

  const calculateWidthByDuration = (duration) => {

    if (!duration)
      return

    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return Math.round(totalMilliseconds / onePxEquivalent); //onePxEquivalent
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const calculateTimeByWidthInMS = (width) => {
    let ms = parseFloat((width * onePxEquivalent).toFixed(3));
    return ms;
  };

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat((width * onePxEquivalent).toFixed(3));
    return msToTime(ms);
  };

  const msToTimeMini = (duration) => {
    var seconds = Math.floor((duration / 1000) % 60),
      minutes = Math.floor((duration / (1000 * 60)) % 60),
      minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return minutes + ":" + seconds;
  };

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };

  // const SendData = (params) => {
  //   setChangeCount(0)
  //   setReloder(false)
  // }

  // useEffect(() => {
  //   if (Reloder === false) {
  //     window.removeEventListener('beforeunload', onBeforeUnload, true);
  //   }
  // }, [Reloder])

  // function onBeforeUnload(e) {
  //   if (Reloder === true) {
  //     //e.preventDefault();
  //     e.returnValue = '';
  //     SendData()
  //     return;
  //   } else {
  //     delete e['returnValue'];
  //   }
  //   //e.returnValue = false;
  //   //return false
  // }

  const [CharacterJsons, setCharacterJsons] = useState({});

  const [Scene, setScene] = useState();

  useEffect(() => {
    if (Clear == true) {
      const array = Array.from(slides);
      let obj = {
        type: "",
        color: null,
        Path: null,
        gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
      };

      for (var i = 0; i < array.length; i++) {
        if (array[i].IsActive === true) {
          array[i].LayerData = [];
          array[i].SlideBackground = obj;
        }
      }

      setLayersData([]);
      setslides(array);
      setClear(false);
    }
  }, [Clear]);

  const [ShowSubMenu, setShowSubMenu] = useState(null);

  const [ReverseLayer, setReverseLayer] = useState([]);
  const [previousLayersData, setPreviousLayersData] = useState([]);

  const [Goto, setGoto] = useState({
    menu: null,
    innerMenu: null,
    key: null,
  });

  useEffect(() => {
    if (Goto.menu != null) {
      if (Goto.menu == "Character") {
        setLeftPanelActive("Assets");
      } else if (Goto.menu == "Props") {
        setLeftPanelActive("Assets");
      } else if (Goto.menu == "Shape") {
        setLeftPanelActive("Assets");
      } else if (Goto.menu == "image") {
        setLeftPanelActive("Images");
      } else if (Goto.menu == "Scene") {
        setLeftPanelActive("Scene");
      } else if (Goto.menu == "Video") {
        setLeftPanelActive("Videos");
      }
    }
  }, [Goto]);

  useEffect(() => {
    console.log('previousLayersData', previousLayersData)
    console.log('LayersData', LayersData)
    console.log('UndoLayer', UndoLayer)
    console.log('!arraysEqual(previousLayersData.current, LayersData)', arraysEqual(previousLayersData, LayersData))
    if (arraysEqual(previousLayersData, LayersData)) {

      if (CanvasDisplay) {
        if (LayersData.length !== 0) {
          //const LockedObj = LayersData.find((x) => x.layerlock == true);
          //if (!LockedObj) setReverseLayer(reverseArr(LayersData));
          setReverseLayer(reverseArr(LayersData));
          console.log('ReverseLayer', ReverseLayer)
        } else {
          setReverseLayer([]);
        }
        setPreviousLayersData(LayersData);

      }
    }
 

  }, [LayersData]);
  // const arraysEqual = (arr1, arr2) => {
  //   console.log('arr1', arr1)
  //   console.log('arr2', arr2)
  //   if (arr1.length == arr2.length) {

  //     for (let i = 0; i < arr1.length; i++) {
  //       console.log('arr1[i].key', arr1[i].key)
  //       console.log('arr2[i].key', arr2[i].key)
  //       console.log('arr1[i].Name', arr1[i].Name)
  //       console.log('arr2[i].Name', arr2[i].Name)
  //       console.log('arr1[i].Name !== arr2[i].Name && arr1[i].key !== arr2[i].key', arr1[i].Name !== arr2[i].Name && arr1[i].key !== arr2[i].key)
  //       if (arr1[i].Name !== arr2[i].Name && arr1[i].key !== arr2[i].key) return true
  //     }
  //   }
  //   return true;
  // };
  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return true; // Different lengths, arrays are different
    }
    if (arr1.length == 0 && arr2.length == 0) {
      return true; // Different lengths, arrays are different
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].Name !== arr2[i].Name || arr1[i].key !== arr2[i].key) {
        return true; // Found a pair of elements that differ, arrays are different
      }
    }

    return false; // All pairs of elements are equal, arrays are equal
  };
  function reverseArr(input) {
    var ret = new Array();
    for (var i = input.length - 1; i >= 0; i--) {
      ret.push(input[i]);
    }
    return ret;
  }

  const [BgCategory, setBgCategory] = useState([
    {
      id: 0,
      name: "User Backgrounds",
      ImagePath: "Assets/BackgroundCategories/user.png",
      data: [],
    },
  ]);

  const [ScenesFolder, setScenesFolder] = useState([
    {
      id: 0,
      categoryName: "User Scenes",
      defaultImgPath: "Assets/scenescategories/user.png",
      data: [],
    },
  ]);

  const [TextCategories, setTextCategories] = useState([]);

  const [charcterFolder, setcharcterFolder] = useState([]);

  const TickerRef = useRef(null);
  const DraggableTextRef = useRef(null);
  const VideoPlayerRef = useRef(null);
  const SoundRef = useRef(null);
  const AnimatedTextRef = useRef(null);
  const [CharacterRef, setCharacterRef] = useState(null);

  const [isPlayClicked, setIsPlayClicked] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  // For TTS Panel
  const [IsTTSShow, setIsTTSShow] = useState(false);
  const [TTSData, setTTSData] = useState(null);
  const [GS_Data, setGS_Data] = useState([]);

  // const [SlidesData, setSlidesData] = useState([])

  return (
    <div
      className="body"
      tabIndex="0"
      onKeyDown={(event) => KeyDownListen(event)}
      onKeyUp={(event) => KeyUpListen(event)}
    >
      <div className="bodywWapper">
        <div className="bodyWrapperInsider">
          <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            <MyContext.Provider
              value={{
                showRecording,
                setshowRecording,
                isTTS,
                setIsTTS,
                setenableAutoGuides,
                enableAutoGuides,
                setenableGrid,
                enableGrid,
                setenableRuler,
                enableRuler,
                setMultiDrag,
                MultiDrag,
                //
                pauseState,
                setpauseState,
                setcheckFunction,
                checkFunction,
                setAciveShapeColor,
                AciveShapeColor,
                isTextInputOrAreaFocus,
                setisTextInputOrAreaFocus,
                editableObject,
                seteditableObject,
                CharacterData,
                Dragging,
                setDragging,
                setCharacterData,
                Tl_TotalTime,
                setTl_TotalTime,
                setLeftToggle,
                LeftToggle,
                Backgrounds,
                setBackgrounds,
                setVideoData,
                VideoData,
                CanvasDisplay,
                setCanvasDisplay,
                timelineZoomVal,
                changeTimelineZoomVal,
                TimelineUndo,
                setLayersData,
                LayersData,
                calculateTimeByWidth,
                TimelineWidth,
                setTimelineWidth,
                scaleLength,
                SoundsData,
                setSoundsData,
                RedoLayer,
                setRedoLayer,
                UndoLayer,
                setUndoLayer,
                previousLayersData,
                setPreviousLayersData,
                clone,
                calculateWidthByDuration,
                LeftPanelActive,
                setLeftPanelActive,
                setImageData,
                ImageData,
                ChangeCount,
                setChangeCount,
                onePxEquivalent,
                setChrPopData,
                setchrPop,
                BgCategory,
                setBgCategory,
                ScenesFolder,
                setScenesFolder,
                TextCategories,
                setTextCategories,
                setEditorZoom,
                EditorZoom,
                ProjectAspectRatio,
                setProjectAspectRatio,
                BasicShapes,
                IsPressedShiftKey,
                setIsPressedShiftKey,
                setBasicShapes,
                msToTimeMini,
                characterId,
                setCharacterId,
                characterEditor,
                setCharacterEditor,
                isPlayClicked,
                setIsPlayClicked,
                DraggableTextRef,
                Previous_Tl_TotalTime,
                setPrevious_TlTotalTime,
                IsPressedShiftKey,
                IsTTSShow,
                setIsTTSShow,
                TTSData,
                setTTSData,
                CharacterRef,
                setCharacterRef,
                VideoPlayerRef,
                AnimatedTextRef,
                Call_ScreenShot,
                setCall_ScreenShot,
                Call_CurrentProject,
                setCall_CurrentProject,
                lottieRef,
                isCrop,
                setIsCrop,
                GS_Data,
                setGS_Data,
                popShow,
                setpopShow,

                // SlidesData, setSlidesData,
                //props.AIContentPopup,
                //props.setAIContentPopup
              }}
            >
              <TickerContext.Provider
                value={{
                  CharacterJsons,
                  setCharacterJsons,
                  Scene,
                  setScene,
                  TickerStart,
                  setTickerStart,
                  charcterFolder,
                  setcharcterFolder,
                  TickerPosition,
                  setTickerPosition,
                  ShowSubMenu,
                  setShowSubMenu,
                  ReverseLayer,
                  setReverseLayer,
                  Goto,
                  setGoto,
                  Click_TickerPosition,
                  setClick_TickerPosition,
                  TickerRef,
                  TickerState,
                  setTickerState,
                  premiumActionsArray,
                  setPremiumActionsArray,
                }}
              >
                <ToastContainer autoClose={2000} />
                {chrPop && (
                  <AssetsPopup
                    positions={ChrPopData}
                    setchrPop={setchrPop}
                    setChrPopData={setChrPopData}
                  />
                )}

                <LeftMenu
                  AIContentPopup={props.AIContentPopup}
                  setAIContentPopup={props.setAIContentPopup}
                  setChrPopData={setChrPopData}
                  setchrPop={setchrPop}
                  key={"Menu-1"}
                />

                <MiddlePortion
                  stage={stage}
                  setStage={setStage}
                  key={"Menu-2"}
                />

                <RightSide key={"Menu-3"} />

                <Bottom
                  unitWidth={unitWidth}
                  perUnitMS={perUnitMS}
                  calculateTimeByWidth={calculateTimeByWidth}
                  key={"Menu-4"}
                />

                <DraggedImg
                  key={"Menu-5"}
                  timelineZoomVal={timelineZoomVal}
                  stage={stage}
                />

                <SlideSettings
                  LayersData={LayersData}
                  setLayersData={setLayersData}
                  data={ActiveIndex}
                  setdata={setActiveIndex}
                  style={ShowSubMenu}
                />
                {showRecording && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      right: "20px",
                    }}
                  >
                    <RecordView
                      showRecording={showRecording}
                      setshowRecording={setshowRecording}
                    />
                  </div>
                )}
              </TickerContext.Provider>
            </MyContext.Provider>
          </LoadingContext.Provider>
        </div>
      </div>
    </div>
  );
};
export default Body;
